module.exports = __webpack_public_path__ + "static/img/left-right-hand-swipe-white.2963234.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/left-right-hand-swipe-white.png
// module id = 811
// module chunks = 4